/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentSplitDto } from './PaymentSplitDto';
import {
    PaymentSplitDtoFromJSON,
    PaymentSplitDtoFromJSONTyped,
    PaymentSplitDtoToJSON,
    PaymentSplitDtoToJSONTyped,
} from './PaymentSplitDto';
import type { FavritApp } from './FavritApp';
import {
    FavritAppFromJSON,
    FavritAppFromJSONTyped,
    FavritAppToJSON,
    FavritAppToJSONTyped,
} from './FavritApp';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { InitiatePaymentTestOptions } from './InitiatePaymentTestOptions';
import {
    InitiatePaymentTestOptionsFromJSON,
    InitiatePaymentTestOptionsFromJSONTyped,
    InitiatePaymentTestOptionsToJSON,
    InitiatePaymentTestOptionsToJSONTyped,
} from './InitiatePaymentTestOptions';

/**
 * 
 * @export
 * @interface InitiatePaymentRequest
 */
export interface InitiatePaymentRequest {
    /**
     * 
     * @type {PaymentProvider}
     * @memberof InitiatePaymentRequest
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    paymentMethod: string;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    orderReference: string;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    paymentReference: string;
    /**
     * 
     * @type {number}
     * @memberof InitiatePaymentRequest
     */
    executingLocationId: number;
    /**
     * 
     * @type {InitiatePaymentRequestCurrencyEnum}
     * @memberof InitiatePaymentRequest
     */
    currency: InitiatePaymentRequestCurrencyEnum;
    /**
     * 
     * @type {number}
     * @memberof InitiatePaymentRequest
     */
    amount: number;
    /**
     * 
     * @type {Array<PaymentSplitDto>}
     * @memberof InitiatePaymentRequest
     */
    paymentSplits: Array<PaymentSplitDto>;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    returnUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    failureReturnUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    shopperLocale?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    terminalId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InitiatePaymentRequest
     */
    printReceipt: boolean;
    /**
     * 
     * @type {InitiatePaymentRequestTerminalTipDistributionTypeEnum}
     * @memberof InitiatePaymentRequest
     */
    terminalTipDistributionType?: InitiatePaymentRequestTerminalTipDistributionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    telephoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    invoiceReference?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    roomNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentRequest
     */
    guestName?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof InitiatePaymentRequest
     */
    unintegratedFields?: { [key: string]: string; };
    /**
     * 
     * @type {InitiatePaymentRequestChannelEnum}
     * @memberof InitiatePaymentRequest
     */
    channel?: InitiatePaymentRequestChannelEnum;
    /**
     * 
     * @type {FavritApp}
     * @memberof InitiatePaymentRequest
     */
    paymentInitiatedByApp?: FavritApp;
    /**
     * 
     * @type {InitiatePaymentTestOptions}
     * @memberof InitiatePaymentRequest
     */
    testOptions?: InitiatePaymentTestOptions;
    /**
     * 
     * @type {boolean}
     * @memberof InitiatePaymentRequest
     */
    sendNotification: boolean;
    /**
     * 
     * @type {number}
     * @memberof InitiatePaymentRequest
     */
    version: number;
}


/**
 * @export
 */
export const InitiatePaymentRequestCurrencyEnum = {
    NOK: 'NOK',
    DKK: 'DKK',
    SEK: 'SEK',
    GBP: 'GBP'
} as const;
export type InitiatePaymentRequestCurrencyEnum = typeof InitiatePaymentRequestCurrencyEnum[keyof typeof InitiatePaymentRequestCurrencyEnum];

/**
 * @export
 */
export const InitiatePaymentRequestTerminalTipDistributionTypeEnum = {
    EXECUTING_LOCATION_GETS_EVERYTHING: 'EXECUTING_LOCATION_GETS_EVERYTHING',
    CUSTOM_DISTRIBUTION: 'CUSTOM_DISTRIBUTION',
    DISTRIBUTE_BASED_ON_PAYMENT_SPLIT_SIZE: 'DISTRIBUTE_BASED_ON_PAYMENT_SPLIT_SIZE'
} as const;
export type InitiatePaymentRequestTerminalTipDistributionTypeEnum = typeof InitiatePaymentRequestTerminalTipDistributionTypeEnum[keyof typeof InitiatePaymentRequestTerminalTipDistributionTypeEnum];

/**
 * @export
 */
export const InitiatePaymentRequestChannelEnum = {
    ANDROID: 'ANDROID',
    IOS: 'IOS',
    WEB: 'WEB'
} as const;
export type InitiatePaymentRequestChannelEnum = typeof InitiatePaymentRequestChannelEnum[keyof typeof InitiatePaymentRequestChannelEnum];


/**
 * Check if a given object implements the InitiatePaymentRequest interface.
 */
export function instanceOfInitiatePaymentRequest(value: object): value is InitiatePaymentRequest {
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('orderReference' in value) || value['orderReference'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('executingLocationId' in value) || value['executingLocationId'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('paymentSplits' in value) || value['paymentSplits'] === undefined) return false;
    if (!('printReceipt' in value) || value['printReceipt'] === undefined) return false;
    if (!('sendNotification' in value) || value['sendNotification'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    return true;
}

export function InitiatePaymentRequestFromJSON(json: any): InitiatePaymentRequest {
    return InitiatePaymentRequestFromJSONTyped(json, false);
}

export function InitiatePaymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiatePaymentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentMethod': json['paymentMethod'],
        'orderReference': json['orderReference'],
        'paymentReference': json['paymentReference'],
        'executingLocationId': json['executingLocationId'],
        'currency': json['currency'],
        'amount': json['amount'],
        'paymentSplits': ((json['paymentSplits'] as Array<any>).map(PaymentSplitDtoFromJSON)),
        'returnUrl': json['returnUrl'] == null ? undefined : json['returnUrl'],
        'failureReturnUrl': json['failureReturnUrl'] == null ? undefined : json['failureReturnUrl'],
        'shopperLocale': json['shopperLocale'] == null ? undefined : json['shopperLocale'],
        'terminalId': json['terminalId'] == null ? undefined : json['terminalId'],
        'printReceipt': json['printReceipt'],
        'terminalTipDistributionType': json['terminalTipDistributionType'] == null ? undefined : json['terminalTipDistributionType'],
        'telephoneNumber': json['telephoneNumber'] == null ? undefined : json['telephoneNumber'],
        'invoiceReference': json['invoiceReference'] == null ? undefined : json['invoiceReference'],
        'roomNumber': json['roomNumber'] == null ? undefined : json['roomNumber'],
        'guestName': json['guestName'] == null ? undefined : json['guestName'],
        'unintegratedFields': json['unintegratedFields'] == null ? undefined : json['unintegratedFields'],
        'channel': json['channel'] == null ? undefined : json['channel'],
        'paymentInitiatedByApp': json['paymentInitiatedByApp'] == null ? undefined : FavritAppFromJSON(json['paymentInitiatedByApp']),
        'testOptions': json['testOptions'] == null ? undefined : InitiatePaymentTestOptionsFromJSON(json['testOptions']),
        'sendNotification': json['sendNotification'],
        'version': json['version'],
    };
}

export function InitiatePaymentRequestToJSON(json: any): InitiatePaymentRequest {
    return InitiatePaymentRequestToJSONTyped(json, false);
}

export function InitiatePaymentRequestToJSONTyped(value?: InitiatePaymentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentMethod': value['paymentMethod'],
        'orderReference': value['orderReference'],
        'paymentReference': value['paymentReference'],
        'executingLocationId': value['executingLocationId'],
        'currency': value['currency'],
        'amount': value['amount'],
        'paymentSplits': ((value['paymentSplits'] as Array<any>).map(PaymentSplitDtoToJSON)),
        'returnUrl': value['returnUrl'],
        'failureReturnUrl': value['failureReturnUrl'],
        'shopperLocale': value['shopperLocale'],
        'terminalId': value['terminalId'],
        'printReceipt': value['printReceipt'],
        'terminalTipDistributionType': value['terminalTipDistributionType'],
        'telephoneNumber': value['telephoneNumber'],
        'invoiceReference': value['invoiceReference'],
        'roomNumber': value['roomNumber'],
        'guestName': value['guestName'],
        'unintegratedFields': value['unintegratedFields'],
        'channel': value['channel'],
        'paymentInitiatedByApp': FavritAppToJSON(value['paymentInitiatedByApp']),
        'testOptions': InitiatePaymentTestOptionsToJSON(value['testOptions']),
        'sendNotification': value['sendNotification'],
        'version': value['version'],
    };
}

